{
  "DATA_ASSISTANT": {
    "TITLE": "Adatasszisztens",
    "NEW_CONVERSATION": "+ Új",
    "LOADING": "Betöltés...",
    "LOADING_MESSAGES": "Üzenetek betöltése...",
    "THINKING": "Gondolkodom...",
    "UNTITLED": "Névtelen beszélgetés",
    "NO_CONVERSATIONS": "Még nincsenek beszélgetések. Kattintson a \"+ Új\" gombra a kezdéshez.",
    "EMPTY_STATE": "Válasszon egy beszélgetést, vagy hozzon létre egy újat a kezdéshez.",
    "SEND": "Küldés",
    "PLACEHOLDER": "Miben segíthetek?",
    "SHOW_SQL": "SQL megjelenítése",
    "NO_ROWS": "Nincsenek visszaadott sorok.",
    "DELETE": "\u00d7",
    "DELETE_CONFIRM": "Beszélgetés törlése",
    "DELETE_CONFIRM_DESCRIPTION": "Biztosan törölni szeretné ezt a beszélgetést? Ez a művelet nem vonható vissza.",
    "DELETE_CONFIRM_YES": "Törlés",
    "CHAT": "Csevegés",
    "REPORTS": "Jelentések",
    "SAVE_TO_REPORT": "Mentés jelentésbe",
    "NEW_REPORT": "Új jelentés",
    "REPORT_NAME": "Jelentés neve",
    "NO_REPORTS": "Még nincsenek mentett jelentések",
    "REPORTS_EMPTY_STATE": "Válasszon ki egy jelentést, vagy hozzon létre egy újat.",
    "REPORT_SAVED": "Mentve a jelentésbe",
    "DELETE_REPORT_CONFIRM": "Jelentés törlése",
    "DELETE_REPORT_CONFIRM_DESCRIPTION": "Biztosan törölni szeretné ezt a jelentést? Minden mentett elem eltávolításra kerül.",
    "DELETE_ITEM_CONFIRM": "Elem eltávolítása",
    "DELETE_ITEM_CONFIRM_DESCRIPTION": "Biztosan el szeretné távolítani ezt az elemet a jelentésből?",
    "EXPORT_CSV": "CSV exportálása",
    "REFRESH": "Frissítés",
    "QUERY_RUNNING": "Lekérdezés futtatása...",
    "QUERY_FAILED": "Lekérdezés sikertelen",
    "AUTO_REFRESH": "Automatikus frissítés",
    "AUTO_REFRESH_NONE": "Kézi",
    "AUTO_REFRESH_30S": "30 másodperc",
    "AUTO_REFRESH_1M": "1 perc",
    "AUTO_REFRESH_5M": "5 perc",
    "AUTO_REFRESH_10M": "10 perc",
    "EDIT_MESSAGE": "Üzenet szerkesztése",
    "RENAME_REPORT": "Jelentés átnevezése",
    "RENAME_ITEM": "Elem átnevezése",
    "MOVE_UP": "Felfelé mozgatás",
    "MOVE_DOWN": "Lefelé mozgatás",
    "COLLABORATORS": {
      "BUTTON": "Közreműködők",
      "TITLE": "A riport közreműködői",
      "DESCRIPTION": "Válassza ki, mely ügynökök és csapatok láthatják ezt a riportot.",
      "AGENTS": "Ügynökök",
      "TEAMS": "Csapatok",
      "SELECT_AGENTS": "Ügynökök kiválasztása",
      "SELECT_TEAMS": "Csapatok kiválasztása",
      "SAVE": "Mentés",
      "SAVED": "Közreműködők frissítve",
      "SAVE_FAILED": "A közreműködők frissítése nem sikerült"
    }
  },
  "DATA_ASSISTANT_CHAT": "Csevegés",
  "DATA_ASSISTANT_REPORTS": "Jelentések"
}
